import { useMemo } from "react";

export function useVotingResults(results) {
    return useMemo(() => {
        return [
            // create dictionary
            results.reduce(
                (indexed, row) => ({
                    ...indexed,
                    [row.id]: row.value,
                }),
                {}
            ),
            // sum all votes
            results.reduce((sum, row) => sum + row.value, 0),
            // max
            Math.max(...results.map(row => row.value)),
        ];
    }, [results]);
}
